export default {
  sections: {
    title: {
      title: 'Pedido confirmado',
      description: 'Tu tarjeta regalo se ha comprado con éxito',
    },
    instructions: {
      title: 'Revisa tu correo',
      description:
        'Hemos enviado los detalles de tu tarjeta regalo y el recibo a tu correo electrónico. El código llegará en 5-10 minutos.',
    },
    details: {
      total: 'Total',
      order_number: 'Número de pedido',
    },
    footer: {
      help: 'Nuestro socio tecnológico Foodamigos nos ayuda a gestionar las tarjetas regalo. Si no recibes la tarjeta regalo o no la encuentras, contáctalos en {{email}}',
      questions: 'Si tienes preguntas generales sobre el canje, contáctanos directamente en {{email}}',
    },
  },
  buttons: {
    go_home: 'Volver al inicio',
    download_pdfs: 'Descargar PDF de tarjeta regalo',
  },
};
